import { render } from "./MinistryExecutionList.vue?vue&type=template&id=2145887c&scoped=true"
import script from "./MinistryExecutionList.vue?vue&type=script&lang=js"
export * from "./MinistryExecutionList.vue?vue&type=script&lang=js"

import "./MinistryExecutionList.vue?vue&type=style&index=0&id=2145887c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2145887c"]])

export default __exports__